import { useTranslation } from 'react-i18next';
import { Box, TextField, Typography, Button } from '@mui/material';
import type { StepProps } from '../../../types/enrollment.types';

interface EmergencyContactStepProps extends StepProps {
  onSkip?: () => void;
}

export default function EmergencyContactStep({
  formData,
  errors,
  onChange,
  onSkip,
}: EmergencyContactStepProps) {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h5" gutterBottom>
          {t('step.emergency')}
        </Typography>
        {onSkip && (
          <Button
            variant="text"
            color="secondary"
            onClick={onSkip}
            sx={{ textTransform: 'none' }}
          >
            {t('button.skip')}
          </Button>
        )}
      </Box>

      <Typography variant="body1" color="text.secondary" sx={{ mb: 1 }}>
        {t('step.emergency.description')}
      </Typography>

      <TextField
        fullWidth
        label={t('field.emergency.name')}
        value={formData.emergencyName}
        onChange={onChange('emergencyName')}
        error={!!errors.emergencyName}
        helperText={errors.emergencyName}
        inputProps={{ style: { fontSize: '1.2rem' } }}
      />

      <TextField
        fullWidth
        type="tel"
        label={t('field.emergency.phone')}
        value={formData.emergencyPhone}
        onChange={onChange('emergencyPhone')}
        error={!!errors.emergencyPhone}
        helperText={errors.emergencyPhone}
        inputProps={{ style: { fontSize: '1.2rem' } }}
      />

      <TextField
        fullWidth
        label={t('field.emergency.relationship')}
        value={formData.emergencyRelationship}
        onChange={onChange('emergencyRelationship')}
        error={!!errors.emergencyRelationship}
        helperText={errors.emergencyRelationship}
        inputProps={{ style: { fontSize: '1.2rem' } }}
      />
    </Box>
  );
}
